module.exports = __webpack_public_path__ + "static/media/group.5833b360.svg";